'use client'

import Link from 'next/link'
import { useSelector } from 'react-redux'
import { selectIsAuthenticated } from '@/store/user/slice'
import Logo from '@/components/Shared/Logo'
import styles from './styles.module.scss'

const contents = {
  description: '目標の先輩を見つけ、企業を知る。',
  descriptionBlock: 'あなたの未来のヒントがここに。',
  button: '会員登録',
  link: '/signup',
}

export default function MemberRegistration() {
  const isAuthenticated = useSelector(selectIsAuthenticated)

  if (isAuthenticated) return null

  return (
    <div className={styles.memberRegistrationWrapper}>
      <div className={styles.memberRegistrationInner}>
        <div className={styles.memberRegistrationTextArea}>
          <Logo color='white' used='memberRegistration' />
          <p className={styles.memberRegistrationText}>
            {contents.description}
            <span className={styles.memberRegistrationBlock}>{contents.descriptionBlock}</span>
          </p>
        </div>
        <Link href={contents.link} className={styles.memberRegistrationButton}>
          {contents.button}
        </Link>
      </div>
    </div>
  )
}
